<template>
    <div class="tag-editor-container">
        <v-editor
            ref="tagEditor"
            v-model="content"
            :limit="limit"
            :default-value="currentContent"
            class="tag-editor"
            :toolbar-options="toolbarOptions"
            :class="{ 'tag-editor-empty-error': isEmptyError }"
            @blur="handleBlur"
        >
            <template slot="toolbar">
                <v-button v-popmenu:tagSelect.click icon="basic_x_line" remote size="small" class="tag-editor-add" />
            </template>
            <v-tag slot="tag" slot-scope="props" color="brand" size="small" :text="props.item.text" />
        </v-editor>
        <v-popselect
            ref="tagSelect"
            :options="options"
            @select="handleAddTag"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        },

        tags: {
            type: Array,
            default() {
                return [];
            },
        },

        limit: {
            type: Number,
            default: 100,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            currentContent: [],
            content: null,
            hasAddTags: [],
            isEmptyError: false,
            toolbarOptions: [{
                kind: 'tag',
                icon: 'basic_x_line',
            }],
        };
    },

    computed: {
        inputLength() {
            if (!this.content) return;
            const lastLineIndex = this.content.lines.length - 1;
            /* eslint-disable consistent-return */
            return this.content.lines.reduce(
                (result, line, i) =>
                /* eslint-disable no-shadow */
                 (
                    line.reduce((result, node) => result + (node.kind === 'text' ? node.text.length : 1), result) + (i === lastLineIndex ? 0 : 1)
                )
            , 0,
);
        },
        options() {
            return this.tags.map(item => ({
                text: item,
                value: item,
                disabled: this.hasIncludeTag(item),
            }));
        },
    },

    watch: {
        content: {
            handler(newContent) {
                this.$emit('on-change', {
                    state: newContent,
                    html: this.getText(this.getRawValue(newContent)),
                    inputLength: this.inputLength,
                });
                this.computedTagStatus(this.getRawValue(newContent));
            },
            deep: true,
        },
    },

    created() {
        this.initData(this.value);
    },

    methods: {
        getRawValue(state) {
            return state && state.toRawValue();
        },
        // 当输入内容发生改变时，需要计算是否了标签等
        computedTagStatus(newContent) {
            this.hasAddTags = [];
            newContent.forEach((item) => {
                if (typeof item === 'object') {
                    this.hasAddTags.push(item.text);
                }
            });
        },
        getText(content) {
            let html = '';
            content.forEach((item) => {
                if (typeof item === 'string') {
                    html += item;
                }
                if (typeof item === 'object') {
                    html += item.text;
                }
            });
            return html;
        },
        handleBlur() {
            this.isEmptyError = this.getText(this.getRawValue(this.content)).length === 0;
        },
        initData(value) {
            this.currentContent = this.transformText2CurrentContent(value);
        },
        hasIncludeTag(tag) {
            return this.hasAddTags.includes(tag);
        },
        // 把文字转换成富文本显示的格式
        transformText2CurrentContent(value) {
            const result = [];
            for (let i = 0; i < value.length; i++) {
                for (let j = 0; j < this.tags.length; j++) {
                    const len = this.tags[j].length;
                    const tag = this.tags[j];
                    if (tag === value.substr(i, len)) {
                        result.push({
                            kind: 'tag',
                            text: tag,
                        });
                        i += len;
                    }
                }
                if (value[i]) {
                    result.push(value[i]);
                }
            }
            return result;
        },
        handleAddTag(tag) {
            if (!this.hasAddTags.includes(tag)) {
                this.hasAddTags.push(tag);
                this.$refs.tagEditor.insert({
                    kind: 'tag',
                    text: tag.value,
                });
                // this.focus();
            }
        },
    },
};
</script>

<style lang="less">
@import '~@/styles/common.less';
.tag-editor-container {
    position: relative;
    width: 100%;
    .empty-error-tip {
        position: absolute;
        right: 0;
        top: -30px;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #ff4222;
    }
}
.tag-editor {
    width: 100%;
    height: auto;
    word-break: break-all;
    box-sizing: border-box;

    &-add {
        border-color: var(--color-brand-1);
        background-color: var(--color-brand-0);
        color: var(--color-brand-5);

        &:hover {
            border-color: var(--color-brand-1);
            background-color: var(--color-brand-0);
            color: var(--color-brand-5);
        }
    }

    .v-editor__limit {
        margin-top: 6px !important;
    }
    .v-editor__txt {
        span[data-kind="text"] {
            vertical-align: -webkit-baseline-middle;
        }
    }

    &__tag {
        display: inline-block;
        padding: 0 2px;
        background-color: #d3e9ff;
    }
    &-link-wrapper {
        display: flex;
    }
    &__link {
        line-height: 0;
        margin-right: 5px;

        &--disable {
            a {
                opacity: 0.4;
                cursor: default;
                pointer-events: none;
            }
        }

        a {
            display: inline-block;
            padding: 0 5px;
            font-size: 14px;
            background-color: #d3e9ff;
            line-height: 24px;

            &:hover {
                color: @mainBlue;
            }
        }
    }

    &__invalid {
        margin-left: 10px;
        color: @AidRed;
    }
}
.tag-editor-empty-error {
    border-color: #ff4222;
    border-bottom-width: 2px;
    &:hover {
        border-color: #ff4222;
    }
}
</style>
